export default __webpack_public_path__ + "static/valued-partners-26ecc2349f5f14c0c30fd2bf5605ed22.svg";